import { render, staticRenderFns } from "./pcProduct.vue?vue&type=template&id=4f9d6974"
import script from "./pcProduct.vue?vue&type=script&lang=js"
export * from "./pcProduct.vue?vue&type=script&lang=js"
import style0 from "./pcProduct.vue?vue&type=style&index=0&id=4f9d6974&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports